module.exports = __webpack_public_path__ + "static/media/Frayed-Hem.734e214f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/denim/Frayed-Hem.jpg
// module id = 138
// module chunks = 0